<template>
    <div class="user-address">
        <Table border :columns="list" ref="userList" :data="tablelist" :loading="dataloading"></Table>
        <!--修改地址-->
        <Modal v-model="showEditStatus" title="修改" @on-ok="updateAddress('addressValidate')" :loading="loading">
            <Form :model="addressInfo" ref="addressValidate" :rules="addressValidate" action="javascript:void(0)">
                <FormItem label="姓名" prop="person">
                    <Input v-model="addressInfo.person" placeholder="输入姓名..." style="width: 500px"></Input>
                </FormItem>
                <FormItem label="电话" prop="phone">
                    <Input v-model="addressInfo.phone" placeholder="输入电话..." type="textarea" style="width: 500px"></Input>
                </FormItem>
                <FormItem >
                    <Select v-model="addressInfo.area_name1" clearable filterable placeholder="省..." @on-change="province">
                        <Option v-for="item in area" :value="item.provinceid" :key="item.provinceid">{{ item.areaname }}</Option>
                    </Select>
                </FormItem>
                <FormItem>
                    <Select v-model="addressInfo.area_name2" clearable filterable placeholder="市..." @on-change="city">
                        <Option v-for="item in area2" :value="item.provinceid" :key="item.provinceid">{{ item.areaname }}</Option>
                    </Select>
                </FormItem>
                <FormItem>
                    <Select v-model="addressInfo.area_name3" clearable filterable placeholder="区...">
                        <Option v-for="item in area3" :value="item.provinceid" :key="item.provinceid">{{ item.areaname }}</Option>
                    </Select>
                </FormItem>
                <FormItem label="地址" prop="address">
                    <Input v-model="addressInfo.address" placeholder="输入详细地址..." type="textarea" style="width: 500px"></Input>
                </FormItem>
                <FormItem>
                    <Select placeholder="状态..." v-model="addressInfo.default" clearable>
                        <Option :value="1">开</Option>
                        <Option :value="0">关</Option>
                    </Select>
                </FormItem>
            </Form>
        </Modal>

    </div>
</template>

<script>
    export default {
        name: "user-address",
        data() {
            return {
                tablelist: [],
                pages: {
                    page: 1,
                    size: 10,
                    total: 0
                },
                addressValidate: {
                    person: [
                        { required: true, message: '姓名必须填写', trigger: 'blur' }
                    ],
                    phone: [
                        { required: true, message: '手机号必须填写', trigger: 'blur' }
                    ],
                    address: [
                        { required: true, message: '地址必须填写', trigger: 'blur' }
                    ],
                },
                id: 0,
                address_id: 0,
                dataloading: false,
                loading: false,
                showEditStatus: false,
                list: [
                    {
                        title: 'Id',
                        key: 'uuid',
                        minWidth: 270,
                        fixed: 'left'
                    },
                    {
                        title: '姓名',
                        width: 120,
                        key: 'person',
                    },
                    {
                        title: '电话',
                        width: 150,
                        key: 'phone',
                    },
                    {
                        title: '省',
                        width: 100,
                        key: 'area_name1',
                    },
                    {
                        title: '市',
                        width: 100,
                        key: 'area_name2',
                    },
                    {
                        title: '区',
                        width: 100,
                        key: 'area_name3',
                    },
                    {
                        title: '地址',
                        width: 200,
                        key: 'address',
                    },
                    {
                        title: '操作',
                        key: 'action',
                        fixed: 'right',
                        width: 100,
                        align: 'left',
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    style: {
                                        marginRight: '8px'
                                    },
                                    props: {
                                        type: 'primary',
                                        size: 'small',
                                    },
                                    on: {
                                        click: () => {
                                            this.showEdit(params.row.id)
                                        }
                                    }
                                }, '修改')
                            ]);
                        }
                    }
                ],
                addressInfo: {},
                area: [],
                area2: [],
                area3: [],
            }
        },
        created: function () {
            this.id = this.$route.params.id;
            this.$api.common.getArea().then(res => {
                this.dataloading = false;
                if (res.code == 200) {
                    for (let i = 0; i < res.result.length; i++) {
                        const city = res.result[i];
                        city.provinceid = city.provinceid.toString()
                    }
                    this.area = res.result;
                    this.$Message.success(res.msg);
                }
            });
            // 取数据
            this.getTableList();
        },
        methods: {
            getTableList: function () {
                this.$api.user.addresslist({id: this.id}).then(res => {
                    this.dataloading = false;
                    if (res.code == 200) {
                        this.tablelist = res.result.list;
                        this.pages.total = res.result.total;
                        this.$Message.success(res.msg);
                    }
                });
                return;
            },
            province(){
                console.log(this.addressInfo)
                var id = ''
                for (let i = 0; i < this.area.length; i++) {
                    const province = this.area[i];
                    if (this.addressInfo.area_name1 == province.provinceid) {
                        id = province.id
                        break
                    }
                }
                if (id == '') {
                    return
                }
                this.$api.common.getArea({parent_id:id}).then(res => {
                    this.dataloading = false;
                    if (res.code == 200) {
                        for (let i = 0; i < res.result.length; i++) {
                            const city = res.result[i];
                            city.provinceid = city.provinceid.toString()
                        }
                        this.area2 = res.result;
                        this.$Message.success(res.msg);
                        this.city()
                    }
                });
            },
            city(){
                console.log(this.addressInfo)
                var id = ''
                for (let i = 0; i < this.area2.length; i++) {
                    const province = this.area2[i];
                    if (this.addressInfo.area_name2 == province.provinceid) {
                        id = province.id
                        break
                    }
                }
                if (id == '') {
                    return
                }
                this.$api.common.getArea({parent_id:id}).then(res => {
                    this.dataloading = false;
                    if (res.code == 200) {
                        for (let i = 0; i < res.result.length; i++) {
                            const city = res.result[i];
                            city.provinceid = city.provinceid.toString()
                        }
                        this.area3 = res.result;
                        this.$Message.success(res.msg);
                    }
                });
            },
            updateAddress() {
                this.$api.user.addressedit(this.addressInfo).then(res => {
                    this.dataloading = false;
                    if (res.code == 200) {
                        this.showEditStatus = false;
                    } else {
                        this.showEditStatus = true;
                    }
                })
                
            },
            // 翻页
            changePage() {
                this.pages.page = this.$refs['listPage'].currentPage;
                this.renderTable(1);
            },
            showEdit(id) {
                this.address_id = id;
                this.$api.user.addressdetail({id: id}).then(res => {
                    this.dataloading = false;
                    if (res.code == 200) {
                        this.addressInfo = res.result;
                        this.province()
                        
                    }
                })
                this.showEditStatus = true;
            },
            // 筛选
            renderTable: function (name) {
                if (name != 1) {
                    this.pages.page = 1;
                }
                var ps = {
                    "page": this.pages.page,
                    "size": this.pages.size,
                    "id": this.id,
                };
                this.$api.user.addresslist(ps).then(res => {
                    this.dataloading = false;
                    if (res.code == 200) {
                        this.tablelist = res.result.list;
                        this.pages.total = res.result.total;
                        this.$Message.success(res.msg);
                    }
                });
                return;
            },
        }
    }
</script>

<style scoped>

</style>